export type PlayerState = "idle" | "playing" | "paused";

export type VolumeAction = "up" | "down" | "mute" | "unmute";

export enum PlatformKeyCode {
  Up = 38,
  Down = 40,
  Right = 39,
  Left = 37,
  Enter = 13,
  Back = 8,
  Play = 415,
  Pause = 19,
  PlayPause = 179,
  Stop = 413,
  Rewind = 412,
  FastForward = 417,
  Previous = 10232,
  Next = 10233,
  ChannelUp = 33,
  ChannelDown = 34,
  Red = 403,
  Green = 404,
  Yellow = 405,
  Blue = 406,
}

export type PlaybackAsset = {
  contentId?: string;
  contentType?: string;
  title?: string;
  subtitle?: string;
  thumbnail?: string;
  isAudioOnly?: boolean;
};

export type PlaybackState = {
  status: PlayerState;
  currentTime?: number;
  duration?: number;
  live?: boolean;
  seekableRange?: { start: number; end: number };
  asset?: PlaybackAsset;
  ad?: boolean;
  muted?: boolean;
  trailer?: boolean;
  ts?: number;
};

export type Capabilities = {
  protocolVersion: number;
  appVersion: string;
  platform: string;
  supportedKeys: PlatformKeyCode[];
  features: string[];
  volumeControl: boolean;
};

/* Messages sent from host and received by remote */
type HostToRemoteMessage =
  | {
      type: "ack";
      payload?: {
        code?: string;
      };
    }
  | {
      type: "capabilities";
      payload: Capabilities;
    }
  | {
      type: "playbackState";
      payload: PlaybackState;
    };

export type HostOutboundMessage = HostToRemoteMessage;

export type RemoteInboundMessage = HostToRemoteMessage;

/* Messages sent from remote and received by host */
type RemoteToHostMessage =
  | {
      type: "ack";
      payload?: {
        clientId?: string;
        profileId?: string;
        name?: string;
      };
    }
  | {
      type: "buttonPress";
      payload: {
        key: PlatformKeyCode;
      };
    }
  | {
      type: "play";
      payload: {
        contentId: string;
        contentType: string;
        autoplay?: boolean;
        /** Start position in seconds. */
        startOffset?: number;
        trailer?: boolean;
      };
    }
  | {
      type: "seek";
      payload: {
        /** Target position in seconds. */
        startOffset: number;
      };
    }
  | {
      type: "volume";
      payload: {
        action: VolumeAction;
      };
    }
  | {
      type: "route";
      payload: {
        routeKey: "storefront" | "search";
        routeParams?: Record<string, string>;
      };
    };

export type RemoteOutboundMessage = RemoteToHostMessage;

export type HostInboundMessage = RemoteToHostMessage;
